/* eslint-disable */

const DEFAULT_CONSTANTS = {
  INVALID_INPUT_MESSAGE: "INPUT SHOULD BE A VALID NUMBER.",
  APP_DESCRIPTION:
    "ENTER YOUR DATE OF BIRTH TO KNOW IF YOUR BIRTHDAY IS PALINDROME OR NOT.",
  PRIVACY_NOTICE: "🛑PRIVACY NOTICE: WE'RE NOT STORING ANY DATA.🛑",
  PALINDROME_MESSAGE: "WHOA! YOUR BIRTHDAY IS PALINDROME!🎂🙃🙂🎂",
};

const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export { DEFAULT_CONSTANTS, DAYS_IN_MONTH };
